import { SpineBase, ingenuity, Container, dispatcher } from "@quest/base-core/dist";
import { Model as platformModel } from "@quest/platform-murka-phase_2/dist/Model/Model";
import { BaseGameView } from "@quest/slot-core";
import { ISpineData } from "@quest/pixi-bridge";

import { ClusterWinFrameView } from "./ClusterWinFrameView";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "../Platform/GameParserModel";
import { gameConstants, spineConstants } from "../Constants/gameConstants";

export class ClusterWinFrameController {
  private view: ClusterWinFrameView;
  private clusterWinFrameMainContainer: Container;

  constructor(view: ClusterWinFrameView, baseGameView: BaseGameView) {
    this.view = view;
    this.initializeElements();
    this.subscribeEvents();
    this.createSpineClone();
  }

  /**
   * Initialize Elements
   */
  private initializeElements(): void {
    this.clusterWinFrameMainContainer = this.view.getContainerByID("ClusterWinFrameMainContainer");
  }

  /**
   * Subscribe events
   */
  private subscribeEvents(): void {
    this.unsubscribeEvents();
    dispatcher.on(eventDispatchers.SHOW_CLUSTER_WIN_FRAME, this.showClusterWinFrame, this);
    dispatcher.on(eventDispatchers.HIDE_CLUSTER_WIN_FRAME, this.hideClusterWinFrame, this);
  }

  /**
   * Unsubscribe events
   */
  private unsubscribeEvents(): void {
    dispatcher.off(eventDispatchers.SHOW_CLUSTER_WIN_FRAME, this.showClusterWinFrame, this);
    dispatcher.off(eventDispatchers.HIDE_CLUSTER_WIN_FRAME, this.hideClusterWinFrame, this);
  }

  // Add to create spine clone animation
  private createSpineClone(): void {
    const symbolEdge: number = 4;
    let totalSymbols = (ingenuity.parserModel as GameParserModel).getNumCols() * (ingenuity.parserModel as GameParserModel).getNumRows();
    for (let i = 0; i < totalSymbols; i++) {
      let winFrameContainer: Container = this.view.getComponentById("ClusterWinFrameContainer_" + i);
      for (let j = 0; j < symbolEdge; j++) {
        let winFrameSpine: SpineBase = this.getSpineJsonAndClone();
        winFrameSpine.x = this.view.json.winFramePosition[j][0];
        winFrameSpine.y = this.view.json.winFramePosition[j][1];
        winFrameContainer.addChild(winFrameSpine);
      }
    }
  }

  // Add to get & clone animation
  private getSpineJsonAndClone(): SpineBase {
    let winFrame: ISpineData = this.view.json[spineConstants.WIN_FRAME];
    let winFrameAnim: SpineBase = this.view.createSpineClone(winFrame);
    winFrameAnim.visible = false;
    return winFrameAnim;
  }

  // Add to show win frame
  private showClusterWinFrame(): void {
    let currentLinesOffset = (ingenuity.parserModel as GameParserModel).getWinSymBounds()[
      (ingenuity.parserModel as platformModel).getWinLinesData().length -
        (ingenuity.parserModel as GameParserModel).getCascadeLineToggleCount()
    ];
    for (let data of currentLinesOffset) {
      let winFramesContainer: Container = this.view.getContainerByID("ClusterWinFrameContainer_" + data.pos);
      winFramesContainer.children[0].visible = data.left;
      winFramesContainer.children[1].visible = data.top;
      winFramesContainer.children[2].visible = data.right;
      winFramesContainer.children[3].visible = data.bottom;
      this.playWinFramesAnim(winFramesContainer);
    }
  }

  // To play win frame animation
  private playWinFramesAnim(winFrame: Container): void {
    let key: string;
    const leftEdge: number = 0;
    const rightEdge: number = 2;
    winFrame.children.forEach((anim: SpineBase, index: number) => {
      if (index === leftEdge || index === rightEdge) {
        key = spineConstants.WINFRAME_VERTICAL;
      } else {
        key = spineConstants.WINFRAME_HORIZONTAL;
      }
      if (anim.visible) {
        this.addTintColorOnWinFrame(anim);
        anim.setPause(false);
        anim.playAnim(key, true);
      }
    }, this);
  }

  // To add tint color on win frame
  private addTintColorOnWinFrame(winFrameAnim: SpineBase): void {
    winFrameAnim.tint = this.getWinFrameColorBasedOnSymbol();
  }

  // To get line win symbol id
  private toFindWinLineSymbolId(): number {
    const winLineData = (ingenuity.parserModel as platformModel).getWinLinesData()[
      (ingenuity.parserModel as platformModel).getWinLinesData().length -
        (ingenuity.parserModel as GameParserModel).getCascadeLineToggleCount()
    ];
    return winLineData.no;
  }

  // To get color for win frame
  private getWinFrameColorBasedOnSymbol(): number {
    let winFrameColor;
    if (gameConstants.BLUE_WIN_FRAME_SYMBOL_ID.indexOf(this.toFindWinLineSymbolId()) !== -1) {
      winFrameColor = gameConstants.BLUE_WIN_FRAME_TINT_COLOR;
    } else {
      winFrameColor = gameConstants.RED_WIN_FRAME_TINT_COLOR;
    }
    return winFrameColor;
  }

  // To hide win frame
  private hideClusterWinFrame(): void {
    this.clusterWinFrameMainContainer.forEach((child: Container) => {
      child.forEach((winFrameAnimation: SpineBase) => {
        if (winFrameAnimation.visible) {
          winFrameAnimation.visible = false;
          winFrameAnimation.setPause(true);
        }
      }, this);
    }, this);
  }
}
